import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { colorGray } from 'styles/layout/colors';
import IconPlay2 from 'components/icons/iconPlay2';
const LivestreamPlayIcon = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="items-center bg-white rounded-[32px] flex h-16 justify-center w-16"><IconPlay2 color={colorGray} className="LivestreamPlayIcon__icon" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default LivestreamPlayIcon;